export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"msapplication-TileColor","content":"#3e2b2e"},{"name":"theme-color","content":"#fff"},{"name":"apple-mobile-web-app-title","content":"Concertgebouw"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicons/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicons/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicons/favicon-96x96.png"},{"rel":"icon","type":"image/svg+xml","href":"/favicons/favicon.svg"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"manifest","href":"/favicons/site.webmanifest"},{"rel":"alternate icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"mask-icon","href":"/favicons/safari-pinned-tab.svg","color":"#a6192e"}],"style":[],"script":[{"key":"boot-diagnostic","data-cookieconsent":"ignore","type":"text/javascript","innerHTML":"(function () {\n  try {\n    var captured = null;\n    window.addEventListener('error', function (event) {\n      try {\n        if (captured) { return; }\n        var message = (event && event.message) || '';\n        var file = (event && event.filename) || '';\n        if (message.indexOf(\"reading 'app'\") === -1 && file.indexOf('paths.mjs') === -1 && file.indexOf('fetch.mjs') === -1) { return; }\n\n        var scripts = [];\n        var nodes = document.getElementsByTagName('script');\n        for (var i = 0; i < nodes.length; i++) {\n          scripts.push({\n            src: nodes[i].src || null,\n            type: nodes[i].getAttribute('type') || '',\n            parent: nodes[i].parentNode ? nodes[i].parentNode.nodeName : null,\n            inline: nodes[i].src ? null : (nodes[i].textContent || '').slice(0, 40)\n          });\n        }\n\n        captured = {\n          message: message,\n          file: file,\n          url: location.pathname,\n          readyState: document.readyState,\n          visibility: document.visibilityState,\n          wasHidden: document.wasDiscarded === true,\n          msSinceNavigation: Math.round(performance.now()),\n          nuxtGlobal: typeof window.__NUXT__,\n          hasConfig: !!(window.__NUXT__ && window.__NUXT__.config),\n          hasPayloadElement: !!document.getElementById('__NUXT_DATA__'),\n          fetchDefined: typeof window.$fetch,\n          bodyExists: !!document.body,\n          scripts: scripts\n        };\n        window.__nuxtBootDiagnostic = captured;\n        console.error('[boot-diagnostic]', JSON.stringify(captured));\n      } catch (inner) {}\n    }, true);\n  } catch (outer) {}\n})();"},{"key":"google-consent-mode-defaults","data-cookieconsent":"ignore","type":"text/javascript","innerHTML":"window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('consent', 'default', {\n  ad_personalization: 'denied',\n  ad_storage: 'denied',\n  ad_user_data: 'denied',\n  analytics_storage: 'denied',\n  functionality_storage: 'denied',\n  personalization_storage: 'denied',\n  security_storage: 'granted',\n  wait_for_update: 2000 // matches GTM Cookiebot implementation settings\n});\ngtag('set', 'ads_data_redaction', true);\ngtag('set', 'url_passthrough', false);"},{"id":"Cookiebot","data-cookieconsent":"ignore","src":"https://consent.cookiebot.com/uc.js","type":"text/javascript","async":true,"data-cbid":"e8696c98-9f22-41bf-8c88-847b7dfe7d0b","data-blockingmode":"auto"}],"noscript":[],"title":"Concertgebouw","htmlAttrs":{"lang":"nl"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = true

export const hasParallelPlugins = false

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = false